import React from "react";
import PropTypes from "prop-types";
import { List } from "antd";

const CompatibleList = props => {
  const { scroll, dataSource, columns, size, rowKey, pagination } = props;
  const style = scroll ? { maxHeight: scroll.y, overflowY: "auto" } : undefined;
  const titleCol = columns.filter(col => col.dataIndex === rowKey)[0] || {};
  return (
    <div style={style}>
      <List
        dataSource={dataSource}
        size={size}
        renderItem={item => (
          <List.Item>
            <List.Item.Meta
              title={titleCol.render ? titleCol.render(item[titleCol.dataIndex], item) : item[titleCol.dataIndex]}
              description={
                <ul style={{ listStyleType: "none", paddingLeft: 8 }}>
                  {columns
                    .filter(col => col.dataIndex !== rowKey)
                    .map(col => (
                      <li key={col.dataIndex}>
                        <strong>{`${col.title}: `}</strong>
                        {col.render ? col.render(item[col.dataIndex], item) : item[col.dataIndex]}
                      </li>
                    ))}
                </ul>
              }
            />
          </List.Item>
        )}
        pagination={pagination}
      />
    </div>
  );
};

CompatibleList.propTypes = {
  dataSource: PropTypes.array.isRequired,
  columns: PropTypes.array.isRequired,
  rowKey: PropTypes.string.isRequired,
  size: PropTypes.oneOf(["small", "default", "large"]),
  pagination: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
  scroll: PropTypes.object
};

export default CompatibleList;
